$('.page-modal').click(function(e){
  e.preventDefault();
  var modalUrl = $(this).data('modal-href');
  showModal('#page-modal', modalUrl);
});

$('.track-order').click(function(e){
  e.preventDefault();
  var waybill_search = $('input[name=waybill_search]').val();
  var modalUrl = $(this).data('modal-href') + '?t=' + waybill_search;
  showModal('#track-order-modal', modalUrl);
});

$('.track-order-link').click(function(e){
  e.preventDefault();
  var waybill_search = $(this).data('shipment');
  var modalUrl = $(this).data('modal-href') + '?t=' + waybill_search;
  showModal('#track-order-modal', modalUrl);
});

$('.login-modal').click(function(e){
  e.preventDefault();
  var modalUrl = $(this).data('modal-href');
  showModal('#login-modal', modalUrl);
});

$('.quick-view').click(function(e){
  e.preventDefault();
  var modalUrl = $(this).data('modal-href');
  showModal('#quick-view-modal', modalUrl);
});

$('.sizes-toggle').click(function(e){
  e.preventDefault();
  var modalUrl = $(this).data('modal-href');
  showModal('#sizes-modal', modalUrl);
});

$('.modal').on('shown.bs.modal', function (e) {
  $("html, body").addClass("overflow-hidden");
});
$('.modal').on('hidden.bs.modal', function (e) {
  $("html, body").removeClass("overflow-hidden");
});

$('#login-modal').on('shown.bs.modal', function () {
  // $('form .pwd-group i').click(function () {
  //   $(this).parent().find('input.form-control').attr('type', (_, attr) => attr == 'password' ? 'text' : 'password')
  //   $(this).attr('class', (_, attr) => attr == 'fas fa-eye' ? 'fas fa-eye-slash' : 'fas fa-eye')
  // })
  $(document).on('click', '.login-form .forgot-password, .fpw-form .login-back', function (e) {
    e.preventDefault();

    if ($(this).hasClass('login-back')) {
      $('.login-box').stop().slideDown('200')
      $('.forgot-password-box').stop().slideUp('200')
      $('#login-tab').addClass('active');
    } else {
      $('.login-box').stop().slideUp('200')
      $('.forgot-password-box').stop().slideDown('200')
      $('#login-tab').removeClass('active');
    }

  })

  $('#login-tab, #register-tab').click(function () {
    $('.login-box').stop().slideDown('200')
    $('.forgot-password-box').stop().slideUp('200')
  })
})

$('#quick-view-modal').on('shown.bs.modal', function () {
  $('html, body').addClass('overflow-hidden');
  setTimeout(() => {
    // Create the main slider.
    var primarySlider = new Splide( '#main-slider', {
      type: 'fade',
      heightRatio: 1.5,
      pagination: false,
      arrows: false,
      cover: true,
      fixedWidth: 345,
      fixedHeight: 518,
      lazyLoad: 'nearby',
      updateOnMove : true,
      preloadPages: 2,
      breakpoints: {
        '992': {
          fixedWidth: 0,
          fixedHeight: 0,
          autoHeight: true,
          heightRatio: 2.1,
        },
      }
    });
    var secondarySlider = new Splide( '#thumbnails-slider', {
      direction: 'ttb',
      height: '518px',
      perPage: 4,
      rewind: true,
      isNavigation: true,
      gap: 7,
      focus: 'center',
      pagination: false,
      fixedWidth: 84,
      fixedHeight: 124,
      lazyLoad: 'nearby',
      preloadPages: 2,
      start: 0,
      trimSpace: true,
      updateOnMove: true,
      // swipeDistanceThreshold: 500,
      breakpoints: {
        '992': {
          fixedWidth: 0,
          // autoHeight: true,
          fixedHeight: 0,
          gap: 2,
          heightRatio: 6,
        }
      }
    }).mount();


    // Set the thumbnails slider as a sync target and then call mount.
    primarySlider.sync( secondarySlider ).mount();

    const main_slider_height = $('#main-slider img').height()
    setTimeout(() => {
      secondarySlider.options = { height: main_slider_height + 'px'};
    }, 10)

    if (checkIfExists('#product-form')) {
      $('.color-select').on('change', function(){
        productColorChange()
        photoColorChange(primarySlider)
      });

      var product_id = $('#product-form input[name=product_id]').val();
      var csrf = $('#product-form input[name=_token]').val();

      $('#product-form').on('submit', function(e){
        e.preventDefault();
        var color_id = $('#product-form select[name=color_id] option:selected').val();
        var size_id = $('#product-form select[name=size_id] option:selected').val();
        var data_form = {
          product_id: product_id,
          color_id: color_id,
          size_id: size_id,
          _token: csrf
        }

        $.ajax({
          url: $(this).attr('action'),
          dataType: 'json',
          type: 'post',
          data: data_form,
          success: function(data){
            $('#cart-messages').html(data.text);
            $('.quick-cart-items').html(data.cart_view);
            $('.quick-cart .counter').html(data.count_products);

            setTimeout(function(){
              $('#cart-messages').html('');
            }, 5000);
          }
        })
      });
    }

  }, 500)
})

$('#quick-view-modal').on('hide.bs.modal', function () {
  $('html, body').removeClass('overflow-hidden');
})
